import { CreditCard, PhoneIncoming, KeyRound, Route } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const STEPS = [
  {
    icon: CreditCard,
    title: "Completa il pagamento",
    desc: "Scegli il piano e completa il pagamento attraverso Stripe.",
  },
  {
    icon: PhoneIncoming,
    title: "Vieni contattato dal team",
    desc: "Dopo il pagamento, Elio o un coach di Fede & Fitness Italia ti contatterà utilizzando i recapiti forniti.",
  },
  {
    icon: KeyRound,
    title: "Attiviamo il tuo accesso",
    desc: "Piano App: riceverai le indicazioni per scaricare l'app e accedere ai contenuti, al social interno e alle chat tematiche. Community Coaching: riceverai le indicazioni per accedere all'app, al gruppo WhatsApp privato e agli incontri settimanali, e le modalità per contattare Elio e Chiara.",
  },
  {
    icon: Route,
    title: "Inizia il tuo percorso",
    desc: "Una volta attivato l'accesso, potrai iniziare a utilizzare i servizi inclusi nel tuo abbonamento.",
  },
];

export const PostPaymentSteps = () => (
  <section id="dopo-pagamento" className="bg-[#121212] py-24 sm:py-32">
    <div className="mx-auto max-w-5xl px-6 lg:px-8">
      <SectionHeading
        eyebrow="Cosa succede dopo il pagamento?"
        title={
          <>
            Hai completato il pagamento.
            <br />E adesso?
          </>
        }
        subtitle="Non devi capire tutto da solo. Ti accompagniamo nell'attivazione del tuo percorso."
        testid="post-payment-heading"
      />
      <ol className="relative space-y-10 border-l border-[#1B1B1B] pl-8 sm:pl-12">
        {STEPS.map((step, i) => (
          <Reveal key={step.title} delay={0.08 * i}>
            <li data-testid={`post-payment-step-${i + 1}`} className="relative">
              <span
                className="absolute -left-[3.30rem] flex h-10 w-10 items-center justify-center rounded-full border border-[#C9A45C] bg-[#080808] sm:-left-[4.30rem]"
                aria-hidden="true"
              >
                <step.icon
                  className="h-5 w-5 text-[#C9A45C]"
                  strokeWidth={1.5}
                />
              </span>
              <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#8F7138]">
                Step {i + 1}
              </p>
              <h3 className="font-display mt-1 text-xl font-semibold text-white sm:text-2xl">
                {step.title}
              </h3>
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-[#B8B8B8] sm:text-base">
                {step.desc}
              </p>
            </li>
          </Reveal>
        ))}
      </ol>
      <Reveal className="mt-16 text-center">
        <p className="font-display text-2xl font-semibold uppercase tracking-wide text-[#C9A45C] sm:text-3xl">
          Dietro Tempio Vivo ci sono persone reali.
        </p>
      </Reveal>
    </div>
  </section>
);
